import { resendVerificationEmailApi } from "@ascendnow/shared";
import { formatErrorMessage, useAscContext } from "../../../";

import { useState } from "react";

export function useResendVerificationEmail(email: string) {
  const { toast } = useAscContext();
  const [loading, setLoading] = useState(false);

  async function resend(_email?: string) {
    if (!_email && !email) {
      toast.error("No email, please provide email");
      return;
    }
    setLoading(true);
    try {
      const { isEmailSent } = await resendVerificationEmailApi(
        email ? email : typeof _email === "string" && _email ? _email : ""
      );

      if (!isEmailSent) {
        throw new Error();
      }
      toast.success(
        `Verification email has been resent to the email address: ${
          _email && typeof _email === "string" ? _email : email
        }`
      );
    } catch (error) {
      toast.error(
        formatErrorMessage(
          error,
          "An error occurred while resending the verification email. Please try again."
        )
      );
    } finally {
      setLoading(false);
    }
  }

  return {
    resend,
    loading,
  };
}
